"use strict";

//import { initFooter } from "./common.js";

$(document).ready(function () {
  $(function () {
    initFooter();
  });
});

function initFooter() {
  var d = new Date();
  var smYear = document.getElementById("smYear");
  if (smYear) {
    smYear.textContent = smYear.textContent.replace("$year", d.getFullYear());
  }
}
